import styled from "styled-components"

export const ProposalBottom = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    width: 100%;
    max-width: 720px;
    margin: 32px auto 0;
    background: ${({ theme }) => theme.colors.interfacePure0};
    padding: 32px 0 0;
    border-top: 1px dashed ${({ theme }) => theme.colors.interfaceText200};

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        max-width: 100%;
        padding: 20px 0 0;
        margin-top: 24px;
    }
`

export const ServicesOptions = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    column-gap: 24px;
    align-items: center;
    width: 100%;
    min-height: 88px;
    padding: 24px;
    background: ${(props: any) => props.theme.colors.background};
    border-radius: 16px;
    margin-bottom: 0;

    color: ${({ theme }) => theme.colors.interfaceText400};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
    overflow-wrap: anywhere;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        row-gap: 16px;
        min-height: auto;
        padding: 20px;
        margin-bottom: 16px;
    }

    .select {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 40px;
        border: 1px solid ${({ theme }) => theme.colors.primaryRed400};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceTextGray};
        cursor: pointer;
        transition: all .3s;
        flex-shrink: 0;
        
        &:hover {
            transform: scale(1.05);
        }

        @media (max-width: 768px) {
            width: 100%;
            height: 44px;
        }

        a {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
        }
    }
`